/**
 * useDealsList — a lista de leads do projeto ativo, da ÚNICA fonte (React Query).
 *
 * Substitui `useStore(s => s.deals)`: a store não guarda mais leads. Quem
 * precisa da lista fora de uma página (Foco do Dia, InsightNotifier, diálogos)
 * lê daqui; é o mesmo cache de `useDeals(projectId)` que o board usa — sem
 * fetch extra, com scores já calculados (`select: scoreAllDeals`).
 */
import { useStore } from '@/store/useStore';
import { useDeals } from '@/hooks/useQueries';
import type { Deal } from '@/store/types';

const EMPTY: Deal[] = [];

export function useDealsList(): { deals: Deal[]; isLoading: boolean } {
  const activeProjectId = useStore((s) => s.activeProjectId);
  const { data, isLoading } = useDeals(activeProjectId);
  return { deals: data ?? EMPTY, isLoading: !!activeProjectId && isLoading };
}
